import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../../buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../../models/Common';
import { iptvApi } from '../../../../../services/apiServices/user/iptv';
import { useCustomSnackbar } from '../../../../../hooks/useCustomEnqueueSnackbar';
import { getErrorMessage } from '../../../../../utils';

interface DeleteIptvDeviceProps {
  handleClose: () => void;
  accountId: string | number;
  deviceId: number;
  macAddress: string;
}

export const DeleteIptvDevice: FC<DeleteIptvDeviceProps> = ({ handleClose, deviceId, accountId, macAddress }) => {
  const { t } = useTranslation();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const [deleteIptvDevice, { isLoading }] = iptvApi.useDeleteDeviceMutation();

  const handleDelete = async () => {
    try {
      await deleteIptvDevice({ accountId, deviceId })
        .unwrap()
        .then(() => {
          customEnqueueSnackbar(t('snackbar.iptvDeviceRemoved'), 'warning');
          handleClose();
        });
    } catch (err) {
      const message = getErrorMessage(err);
      customEnqueueSnackbar(message, 'error');
    }
  };

  return (
    <div className="modals">
      <div className="modals__header">
        <article className="modals__header__title">{t('modals.removeIptvDevice')}</article>
        <p className="modals__header__description">
          {t('modals.areYouSureYouWantToDeleteDevice')} <strong>{macAddress}</strong>?
        </p>
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('buttons.delete')}
          handleClick={handleDelete}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
          isLoading={isLoading}
        />
        <CustomMUIButton
          label={t('buttons.cancel')}
          handleClick={handleClose}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
        />
      </div>
    </div>
  );
};
